import { useEffect } from 'react';
import { App as CapacitorApp } from '@capacitor/app';

import { useGetPublicSystemSettingsQuery } from 'services/publicTeamHeroApi.service';
import { isApiVersionInRange } from './isApiVersionInRange.helper';
import {
  DEV_API_VERSION,
  MAXIMUM_SUPPORTED_API_VERSION,
  MINIMUM_SUPPORTED_API_VERSION,
} from './apiVersion.constants';

interface IUseCompatibilityGateReturn {
  isBlocked: boolean;
  isMaintenance: boolean;
}

const useCompatibilityGate = (): IUseCompatibilityGateReturn => {
  const { data, refetch } = useGetPublicSystemSettingsQuery();

  useEffect(() => {
    const listenerPromise = CapacitorApp.addListener('resume', refetch);
    return () => {
      listenerPromise.then((listener) => listener.remove());
    };
  }, [refetch]);

  const apiVersion = data?.settings.major_api_version;

  return {
    isBlocked:
      apiVersion !== DEV_API_VERSION &&
      !isApiVersionInRange(apiVersion, {
        min: MINIMUM_SUPPORTED_API_VERSION,
        max: MAXIMUM_SUPPORTED_API_VERSION,
      }),
    isMaintenance: data?.settings.is_maintenance === true,
  };
};

export default useCompatibilityGate;
